import { AppRoute, WithRequired } from "./types";

//:- All Application Pages
import HubLogin from "../pages/login";
import HubForgotPassword from  '../pages/forgotpassword';
import NewEnrollment from "../pages/newEnrollment";
import HubUploadPEF from "../pages/uploadPEF";
import HubResetPassword from "../pages/resetpassword";
import Dashboard from "../pages/dashboard";
import HubAddCase from "../pages/addCase";
// import HubCreateUser from "../pages/createUser";
import HubCaseDetail from "src/pages/caseDetail";
import AddProvider from "../pages/addProvider";
import AddUser from "../pages/addUser";
import NewRepVisit from "../pages/newRepVisit";
import BaaAgreement from "../pages/baa";
import manufacturer from "src/pages/manufacturer";
import HubCaseClone from "src/pages/cloneCase";
import TreatmentListing from "src/pages/treatmentListing";
import OrderListing from "src/pages/orderListing";
import PatientListing from "src/pages/patient";
import ActionDashboardListing from "src/pages/actionDashboard";
import UpdatePatient from "src/pages/updatePatient";
import ActionDashboardManufactureListing from "src/pages/manufacturer/actionDashboard";
import PatientManufacturerListing from "src/pages/manufacturer/patient";
import Manufacturer from "src/pages/manufacturer";
// import GlobalPatient from "src/pages/manufacturer/globalPatient";
import DoctorStatistics from "src/pages/doctorStatistics";
import Territories from "src/pages/territories";
import Region from "src/pages/region";
import Area from "src/pages/area";
import Precert from "src/pages/precert";
import Review from "src/pages/review";
import ExplanationOfBenefit from "src/pages/EOBsListing";
import EOBsDetail from "src/pages/EOBsDetail";
import UploadEOBs from "src/pages/uploadEOBs";
import MarkCaseForm from "src/components/modals/markCaseCEP";
import District from "src/pages/district";
import HubInitialUser from "src/pages/initialUser";
import HubLogout from "src/pages/logout";
import YearEndEmail from "src/pages/yearEndEmail";
import EnrollNurse from "../pages/enrollNurse";

const defaultRoute: WithRequired<WithRequired<Partial<AppRoute>, 'isIndex'>, 'removeHeaderandFooter'> = {
  isIndex: false,
  removeHeaderandFooter: false,
};

export const PublicRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/users/sign_in', component: HubLogin, isIndex: true },
  { ...defaultRoute, route: '/enrollments/new', component: NewEnrollment },
  // { ...defaultRoute, route: '/users/forgotpassword', component: HubForgotPassword },
  { ...defaultRoute, route: '/users/password/new', component: HubForgotPassword },
  { ...defaultRoute, route: '/users/uploadPEF', component: HubUploadPEF },
  { ...defaultRoute, route: '/enroll', component: EnrollNurse },
  { ...defaultRoute, route: '/set_new_password', component: HubResetPassword, removeHeaderandFooter: true },
  { ...defaultRoute, route: '/enroll', component: EnrollNurse },
  { ...defaultRoute, route: '/enrollments/new', component: NewEnrollment },
];

export const AuthenticatedRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/cases', component: Dashboard, isIndex: true },
  { ...defaultRoute, route: '/cases/new', component: HubAddCase },
  { ...defaultRoute, route: '/cases/:caseId/clone', component: HubCaseClone },
  { ...defaultRoute, route: '/cases/:caseId', component: HubCaseDetail },
  { ...defaultRoute, route: '/users/:id/edit', component: HubInitialUser },
  { ...defaultRoute, route: '/global_doctors/new', component: AddProvider },
  { ...defaultRoute, route: '/users/new', component: AddUser },
  { ...defaultRoute, route: '/rep_visits/new', component: NewRepVisit },
  { ...defaultRoute, route: '/treatments', component: TreatmentListing },
  { ...defaultRoute, route: '/orders', component: OrderListing },
  { ...defaultRoute, route: '/pages/baa', component: BaaAgreement },
  { ...defaultRoute, route: '/statistics', component: manufacturer },
  { ...defaultRoute, route: '/territories/:Id', component: Territories },
  { ...defaultRoute, route: '/patient_dashboards', component: PatientListing },
  { ...defaultRoute, route: '/todos', component: ActionDashboardListing },
  { ...defaultRoute, route: '/global_patients/:patientId/edit', component: UpdatePatient },
  { ...defaultRoute, route: '/cases/:caseId/precerts/:precertId/edit', component: Precert },
  { ...defaultRoute, route: '/cases/:caseId/precerts/:precertsId/review', component: Review },
  { ...defaultRoute, route: '/eobs', component: ExplanationOfBenefit },
  { ...defaultRoute, route: '/EOBs/detail/:id', component: EOBsDetail },
  { ...defaultRoute, route: '/eobs/new', component: UploadEOBs },
  { ...defaultRoute, route: '/cep', component: MarkCaseForm },
  { ...defaultRoute, route: '/users/sign_out', component: HubLogout, removeHeaderandFooter: true },
  { ...defaultRoute, route: '/pages/year_end_email', component: YearEndEmail },
];

export const ManufacturerRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/todos_statistics', component: ActionDashboardManufactureListing, isIndex: true },
  { ...defaultRoute, route: '/statistics', component: Manufacturer },
  { ...defaultRoute, route: '/territories/:Id', component: Territories },
  { ...defaultRoute, route: '/regions/:Id', component: Region },
  { ...defaultRoute, route: '/users/:id/edit', component: HubInitialUser },
  { ...defaultRoute, route: '/areas/:Id', component: Area },
  { ...defaultRoute, route: '/district/:Id', component: District },
  { ...defaultRoute, route: '/doctor_stats/:Id', component: DoctorStatistics },
  { ...defaultRoute, route: '/patient_statistics', component: PatientManufacturerListing },
  { ...defaultRoute, route: '/cases/:caseId', component: HubCaseDetail },
  { ...defaultRoute, route: '/global_patients/:patientId/edit', component: UpdatePatient },
  { ...defaultRoute, route: '/eobs', component: ExplanationOfBenefit },
  { ...defaultRoute, route: '/EOBs/detail/:id', component: EOBsDetail },
  { ...defaultRoute, route: '/eobs/new', component: UploadEOBs },
  { ...defaultRoute, route: '/users/sign_out', component: HubLogout, removeHeaderandFooter: true },
];
